/* eslint-disable indent */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * AddEmailReceipient
 *
 */

import React, { memo, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import {
  Modal,
  ModalContent,
  ModalHeader,
  Button,
  AlertModal,
  Checkbox,
  InputField,
} from '@cashfree-intl/coherent';
import { isEmpty, keyBy } from 'lodash';

import { MerchantContext } from 'contexts/MerchantContext';
import useClickOutside from 'utils/hooks';
import CustomIcon from 'components/CustomIcons';
import FormikComponent from 'components/Formik';

import {
  EMAIL_CHANNELS,
  EMAIL_CHANNELS_FOR_IMPORT_MERCHANTS,
} from '../../constants';
import validationSchema, { validate } from './validation';

function AddEmailReceipient({
  open,
  closeModal,
  handleFormSubmit,
  receipientAdded,
  closeModalAndRefresh,
  data,
  errorInAddingRecipient,
}) {
  const modalRef = useRef(null);
  const { isMerchantImportEnabled } = useContext(MerchantContext);
  useClickOutside(modalRef, closeModal);

  const getEmailCategoryCheckboxField = ({
    values,
    handleFieldBlur,
    handleFieldChange,
    disabledField,
  }) => {
    const indexedDataByKey = keyBy(data, 'key');
    const emailChannels = isMerchantImportEnabled
      ? EMAIL_CHANNELS_FOR_IMPORT_MERCHANTS
      : EMAIL_CHANNELS;
    return emailChannels.map(obj => {
      const emailData = indexedDataByKey[obj.value];
      const isMaxLimitReached = emailData.emailLeftCount <= 0;
      const emailCountText = `(${emailData.emailLeftCount} left)`;

      const checkboxLabel = (
        <label>
          {obj.displayText} <span className="text-light">{emailCountText}</span>
        </label>
      );

      return (
        <div key={obj.key}>
          <Checkbox
            id={obj.value}
            name={obj.value}
            label={checkboxLabel}
            checked={!!values[obj.value]}
            onChange={handleFieldChange}
            onBlur={handleFieldBlur}
            disabled={disabledField || isMaxLimitReached}
            className="email-category-checkbox"
          />
        </div>
      );
    });
  };

  const afterFormSubmitModalContent = () =>
    errorInAddingRecipient ? (
      <AlertModal
        type="danger"
        title="Error in adding recipient"
        onClose={closeModalAndRefresh}
        eventNameOnClose="Error_in_adding_recipient_Close"
      >
        <div className="success-description">{errorInAddingRecipient}</div>
      </AlertModal>
    ) : (
      <div className="modal-content-success">
        <div className="success-icon">
          <CustomIcon componentName="GREEN_TICK_BIG" />
        </div>
        <div className="success-message">Recipient Added Successfully</div>
        <div className="success-description">
          An email notification will be sent to the recipient confirming their
          approval.
        </div>
        <div className="success-cta-wrapper">
          <Button
            primary
            onClick={closeModalAndRefresh}
            data-event-name="Primary_Button_Close"
          >
            Close
          </Button>
        </div>
      </div>
    );

  const showViewAfterFormSubmit = receipientAdded || errorInAddingRecipient;

  return (
    <Modal
      open={open}
      className={`common-modal-wrapper add-receipient-modal ${
        showViewAfterFormSubmit ? 'success-view' : ''
      }`}
      ref={modalRef}
    >
      {!showViewAfterFormSubmit && (
        <ModalHeader>
          <div>
            <div className="heading">Add Recipient</div>
          </div>
          <div
            className="close-modal"
            onClick={closeModal}
            data-event-name="Form_AddEmailReceipient_Icon_Close"
            data-ignore-inner-text="true"
          >
            <CustomIcon componentName="CLOSE" />
          </div>
        </ModalHeader>
      )}
      <ModalContent>
        {showViewAfterFormSubmit ? (
          afterFormSubmitModalContent()
        ) : (
          <div className="modal-content">
            <FormikComponent
              initialValues={{
                email: '',
                trEm: false,
                rskEm: false,
                rfEm: false,
                disEm: false,
                stEm: false,
                pgSrUp: false,
              }}
              validationSchema={validationSchema}
              validate={validate}
              onSubmit={handleFormSubmit}
            >
              {({
                values = {},
                handleFieldBlur,
                handleFieldChange,
                handleSubmit,
                errors,
                touched,
                ...formikProps
              }) => {
                const { email, ...rest } = touched;
                const disabledField =
                  !formikProps.isValidating && formikProps.isSubmitting;

                return (
                  <form autoComplete="off" onSubmit={handleSubmit}>
                    <InputField
                      fluid
                      id="email"
                      name="email"
                      label="Enter Email Address"
                      value={values.email}
                      errors={errors}
                      touched={touched}
                      placeholder=""
                      onChange={handleFieldChange}
                      onBlur={handleFieldBlur}
                      disabled={disabledField}
                    />
                    <div className="text-light mt-1">
                      We will send a confirmation email. Kindly click on confirm
                      button to start receiving emails.
                    </div>
                    <div className="email-categories-wrapper">
                      <div className="text-light normal-text">
                        Select Email Categories
                      </div>
                      {/* <div className="small-text text-light">
                        Know more about <a>email categories</a>
                      </div> */}
                      <div className="text-light">
                        Maximum of 5 recipients are allowed for each email
                        category.
                      </div>
                      <div className="form-input-wrapper email-categories">
                        {getEmailCategoryCheckboxField({
                          values,
                          handleFieldBlur,
                          handleFieldChange,
                          disabledField,
                        })}
                      </div>
                      {errors.emailTypes &&
                        Object.keys(rest).some(key => !!rest[key]) && (
                          <div className="error-message">
                            {errors.emailTypes}
                          </div>
                        ) // eslint-disable-line
                      }
                    </div>
                    <div className="cta-wrapper">
                      <Button
                        link
                        type="button"
                        className="link"
                        onClick={closeModal}
                        disabled={disabledField}
                        data-event-name="Form_AddEmailReceipient_Button_Close"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        loading={disabledField}
                        disabled={
                          !formikProps.isValid ||
                          disabledField ||
                          isEmpty(touched)
                        }
                        primary
                        data-event-name="Primary_Button_Submit"
                      >
                        Submit
                      </Button>
                    </div>
                  </form>
                );
              }}
            </FormikComponent>
          </div>
        )}
      </ModalContent>
    </Modal>
  );
}

AddEmailReceipient.propTypes = {
  open: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  receipientAdded: PropTypes.bool.isRequired,
  closeModalAndRefresh: PropTypes.func.isRequired,
  data: PropTypes.array,
  errorInAddingRecipient: PropTypes.string,
};

export default memo(AddEmailReceipient);
